/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      DynamicCalculateMechanisms: 'DynamicCalculateMechanism|DynamicCalculateMechanisms',

};
